<template>
    <div class="c-row settlement-preview">
        <div class="c-tr">
            <div class="c-td is-1">
                <div class="typo-name text-uppercase">Nazwa promocji</div>
                <span class="font-weight-bold">{{
                    data.usage.promo.name
                }}</span>
            </div>
            <div class="c-td is-2">
                <div class="typo-name text-uppercase">
                    Data użycia / sprzedaży
                </div>
                <div class="notesTable-ranges">
                    <span>
                        <strong>{{
                            $moment(data.usage.receipt_date).format(
                                'DD-MM-YYYY'
                            )
                        }}</strong>
                    </span>
                </div>
            </div>
            <div class="c-td is-3">
                <div class="typo-name text-uppercase">
                    Liczba odrzuconych użyć
                </div>
                <span class="font-weight-bold">
                    {{ (+data.usage.amount).toFixed() }}
                </span>
            </div>
            <div class="c-td is-4">
                <div class="typo-name text-uppercase">
                    EAN Produktu
                </div>
                <div class="notesTable-ranges">
                    <span>
                        <strong>{{ data.ean }}</strong>
                    </span>
                </div>
            </div>
            <div class="c-td is-5">
                <div class="typo-name text-uppercase">Kod promocji</div>
                <span class="font-weight-bold">{{
                    data.usage.promo.identifier
                }}</span>
            </div>
            <div class="c-td c-td--button">
                <button
                    class="btn btn-auto c-promos-toggle"
                    :class="{ 'btn-expanded': showMore }"
                    data-toggle="collapse"
                    aria-expanded="false"
                    @click="showMore = !showMore"
                >
                    <a-icon icon="Dropdown" />
                    <span class="d-inline d-lg-none">{{
                        showMore ? 'Zwiń' : 'Rozwiń'
                    }}</span>
                </button>
            </div>
            <div class="c-td is-6" :class="{ 'c-td--visible': showMore }">
                <div class="typo-name text-uppercase">ID Użycia Promocji</div>
                <span class="font-weight-bold">{{ data.id }}</span>
            </div>
            <div class="c-td is-7" :class="{ 'c-td--visible': showMore }">
                <div class="typo-name text-uppercase">Stan sklepu</div>
                <span class="font-weight-bold">{{
                    merchantStates[data.usage.merchant.state]
                }}</span>
            </div>
            <div class="c-td is-8">
                <div
                    class="typo-name font-weight-bold text-underline text-uppercase d-flex align-items-center mb-2"
                >
                    Komentarz
                    <a-icon class="ml-1 text-warning" icon="Warning" />
                </div>
                <span>{{ data.usage.comment }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import merchantStates from '@/dictionaries/merchantStates'

export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            merchantStates,
            showMore: false
        }
    },
    computed: {},
    methods: {}
}
</script>
